var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{attrs:{"editor-toolbar":_vm.custom_toolbar},on:{"blur":_vm.onEditorBlur},model:{value:(_vm.editor_content),callback:function ($$v) {_vm.editor_content=$$v},expression:"editor_content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }